"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm._t("default"), _vm.showTag ? _c("div", {
    staticClass: "tag-list"
  }, [_vm._l(_vm.showedCheckedList, function (item) {
    return [item[_vm.replaceFields.title].length > _vm.maxTagTextCount ? _c("a-tooltip", {
      key: item[_vm.replaceFields.value],
      attrs: {
        title: item[_vm.replaceFields.title]
      }
    }, [_c("a-tag", {
      key: item[_vm.replaceFields.value],
      staticClass: "tag-list_item",
      attrs: {
        closable: ""
      },
      on: {
        close: () => _vm.handleTagClose(item)
      }
    }, [_vm._v(" " + _vm._s(`${item[_vm.replaceFields.title].slice(0, _vm.maxTagTextCount)}...`) + " ")])], 1) : _c("a-tag", {
      key: "tag_" + item[_vm.replaceFields.value],
      staticClass: "tag-list_item",
      attrs: {
        closable: ""
      },
      on: {
        close: () => _vm.handleTagClose(item)
      }
    }, [_vm._v(" " + _vm._s(item[_vm.replaceFields.title]) + " ")])];
  }), _vm.count > 0 && _vm.maxTagCount !== 0 ? _c("a-tag", {
    staticClass: "tag-list_item"
  }, [_vm._v("+" + _vm._s(_vm.count))]) : _vm._e()], 2) : _vm._e(), _c("a-input-search", {
    attrs: {
      placeholder: _vm.searchPlaceholder,
      "allow-clear": ""
    },
    on: {
      change: _vm.onSearchInputChange
    },
    model: {
      value: _vm.keyword,
      callback: function ($$v) {
        _vm.keyword = $$v;
      },
      expression: "keyword"
    }
  }), _vm.showAlert ? _c("a-alert", {
    staticClass: "my-alert",
    scopedSlots: _vm._u([{
      key: "message",
      fn: function () {
        return [_vm._v(" 共 "), _c("span", {
          staticClass: "my-alert_text"
        }, [_vm._v(_vm._s(_vm.dataSource.length))]), _vm._v(" 条数据，当前选中 "), _c("span", {
          staticClass: "my-alert_text"
        }, [_vm._v(_vm._s(_vm.allCheckedValueList.length))]), _vm._v(" 条数据 "), _vm.keyword ? _c("span", [_vm._v(" ，共有"), _c("span", {
          staticClass: "my-alert_text"
        }, [_vm._v(_vm._s(_vm.targetList.length))]), _vm._v("条数据符合搜索条件 ")]) : _vm._e()];
      },
      proxy: true
    }], null, false, 2149523298)
  }) : _vm._e(), _vm.multiple ? _c("div", {
    staticClass: "check-all"
  }, [_c("a-checkbox", {
    attrs: {
      indeterminate: _vm.indeterminate,
      checked: _vm.checkAll
    },
    on: {
      change: _vm.onCheckAllChange
    }
  }, [_vm._v(" " + _vm._s(_vm.checkAll ? "取消全选当前列表" : "全选当前列表") + " ")])], 1) : _vm._e(), _vm.targetList.length === 0 ? _c("div", {
    staticClass: "empty",
    style: {
      height: _vm.scrollHeight,
      marginBottom: "15px"
    }
  }, [_c("a-empty", {
    attrs: {
      description: "没有符合条件的数据"
    }
  })], 1) : _c("div", [_vm.multiple ? _c("a-checkbox-group", {
    staticStyle: {
      width: "100%",
      "margin-top": "8px"
    },
    model: {
      value: _vm.checkedValueList,
      callback: function ($$v) {
        _vm.checkedValueList = $$v;
      },
      expression: "checkedValueList"
    }
  }, [_c("RecycleScroller", _vm._b({
    style: {
      height: _vm.scrollHeight
    },
    attrs: {
      items: _vm.targetList,
      "key-field": _vm.replaceFields.key
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        item
      }) {
        return [_c("a-tooltip", {
          attrs: {
            placement: _vm.tooltipPlacement
          },
          scopedSlots: _vm._u([_vm.$scopedSlots.tooltipTitle ? {
            key: "title",
            fn: function () {
              return [_vm._t("tooltipTitle", null, {
                item: item
              })];
            },
            proxy: true
          } : null], null, true)
        }, [_c("a-checkbox", {
          staticStyle: {
            display: "inline-flex",
            "align-items": "center"
          },
          attrs: {
            value: item[_vm.replaceFields.value]
          },
          on: {
            change: _vm.onCheckChange
          }
        }, [_vm._t("checkboxLabel", function () {
          return [_c("span", {
            staticClass: "line-1"
          }, [_vm._v(_vm._s(item[_vm.replaceFields.title]))])];
        }, {
          item: item
        })], 2)], 1)];
      }
    }], null, true)
  }, "RecycleScroller", _vm.scrollerProps, false))], 1) : _c("a-radio-group", {
    staticStyle: {
      width: "100%",
      "margin-top": "8px"
    },
    model: {
      value: _vm.checkedValueList,
      callback: function ($$v) {
        _vm.checkedValueList = $$v;
      },
      expression: "checkedValueList"
    }
  }, [_c("RecycleScroller", _vm._b({
    style: {
      height: _vm.scrollHeight
    },
    attrs: {
      items: _vm.targetList,
      "key-field": _vm.replaceFields.key
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        item
      }) {
        return [_c("a-tooltip", {
          attrs: {
            placement: _vm.tooltipPlacement
          },
          scopedSlots: _vm._u([_vm.$scopedSlots.tooltipTitle ? {
            key: "title",
            fn: function () {
              return [_vm._t("tooltipTitle", null, {
                item: item
              })];
            },
            proxy: true
          } : null], null, true)
        }, [_c("a-radio", {
          staticStyle: {
            display: "inline-flex",
            "align-items": "center"
          },
          attrs: {
            value: item[_vm.replaceFields.value]
          },
          on: {
            change: _vm.onRadioChange
          }
        }, [_vm._t("checkboxLabel", function () {
          return [_c("span", {
            staticClass: "line-1"
          }, [_vm._v(_vm._s(item[_vm.replaceFields.title]))])];
        }, {
          item: item
        })], 2)], 1)];
      }
    }], null, true)
  }, "RecycleScroller", _vm.scrollerProps, false))], 1)], 1), _vm._t("footer")], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;